import { ERROR_ACTION, WAIT_FOR_ACTION } from "redux-wait-for-action";

export const actionTypes = {
    AUDIT_ASSET_ITEM_CLEAR: "AUDIT_ASSET_ITEM_CLEAR",
    AUDIT_ASSET_ITEM_SET: "AUDIT_ASSET_ITEM_SET",
    AUDIT_ASSET_ITEM_UPDATE: "AUDIT_ASSET_ITEM_UPDATE",

    AUDIT_ASSETS_CLEAR: "AUDIT_ASSETS_CLEAR",

    AUDIT_ASSETS_PATCH_FAILURE: "AUDIT_ASSETS_PATCH_FAILURE",
    AUDIT_ASSETS_PATCH_REQUEST: "AUDIT_ASSETS_PATCH_REQUEST",
    AUDIT_ASSETS_PATCH_SUCCESS: "AUDIT_ASSETS_PATCH_SUCCESS",

    AUDIT_ASSETS_POST_FAILURE: "AUDIT_ASSETS_POST_FAILURE",
    AUDIT_ASSETS_POST_REQUEST: "AUDIT_ASSETS_POST_REQUEST",
    AUDIT_ASSETS_POST_SUCCESS: "AUDIT_ASSETS_POST_SUCCESS",

    AUDIT_ASSETS_SET: "AUDIT_ASSETS_SET",
    AUDIT_ASSET_UPDATE_ASSET: "AUDIT_ASSET_UPDATE_ASSET"
};

export const actionCreators = {
    clear: () => ({
        type: actionTypes.AUDIT_ASSETS_CLEAR
    }),

    itemClear: () => ({
        type: actionTypes.AUDIT_ASSET_ITEM_CLEAR
    }),
    itemSet: (auditAsset: any) => ({
        type: actionTypes.AUDIT_ASSET_ITEM_SET,
        payload: { auditAsset }
    }),
    itemUpdate: (auditAsset: any) => ({
        type: actionTypes.AUDIT_ASSET_ITEM_UPDATE,
        payload: { auditAsset }
    }),

    patchRequest: (auditAssets: Array<any>) => ({
        type: actionTypes.AUDIT_ASSETS_PATCH_REQUEST,
        payload: { auditAssets },
        [WAIT_FOR_ACTION]: actionTypes.AUDIT_ASSETS_PATCH_SUCCESS,
        [ERROR_ACTION]: actionTypes.AUDIT_ASSETS_PATCH_FAILURE
    }),
    patchSuccess: (auditAssets: Array<any>) => ({
        type: actionTypes.AUDIT_ASSETS_PATCH_SUCCESS,
        payload: { auditAssets }
    }),
    patchFailure: (error) => ({
        type: actionTypes.AUDIT_ASSETS_PATCH_FAILURE,
        error
    }),

    postRequest: (auditAssets: Array<any>) => ({
        type: actionTypes.AUDIT_ASSETS_POST_REQUEST,
        [WAIT_FOR_ACTION]: actionTypes.AUDIT_ASSETS_POST_SUCCESS,
        [ERROR_ACTION]: actionTypes.AUDIT_ASSETS_POST_FAILURE,
        payload: { auditAssets }
    }),
    postSuccess: (auditAssets: Array<any>) => ({
        type: actionTypes.AUDIT_ASSETS_POST_SUCCESS,
        payload: { auditAssets }
    }),
    postFailure: (error: Error) => ({
        type: actionTypes.AUDIT_ASSETS_POST_FAILURE,
        error
    }),

    set: (auditAssets: Array<any>) => ({
        type: actionTypes.AUDIT_ASSETS_SET,
        payload: { auditAssets }
    }),

    updateAsset: (asset) => ({
        type: actionTypes.AUDIT_ASSET_UPDATE_ASSET,
        payload: { asset }
    })
};
export default {
    create: actionCreators,
    type: actionTypes
};
